function createDayArray(count) {
    const items = []
    for(let i = 1; i <= count; i++) {
        items.push(i)
    }
    return items
}

export default createDayArray